import { Currency } from '@/core/currency/interfaces';

const TMT: Currency = {
    name: 'Turkmenistan Manat',
    demonym: 'Turkmenistan',
    majorSingle: 'Manat',
    majorPlural: 'Manat',
    codeNumeric: '934',
    symbol: 'm.',
    symbolNative: 'T',
    minorSingle: 'Tenge',
    minorPlural: 'Tenge',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'TMT',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default TMT;
